
function About() {
    return <div>Hello. This is Sohaib</div>
}

export default About;